import React, { Component } from 'react'
import { FormControl, RadioGroup, FormControlLabel, Radio } from '@mui/material'
import { FormInputLabel } from '@/shared/ui/input'

class DefFieldUserSettings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            multiple:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.multiple === true
                    ? true
                    : false,
            error: false,
        }

        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(event) {
        const multiple = event.target.value === 'true'
        this.setState({ multiple })
        this.props.onChange('multiple', multiple)
    }

    render() {
        const kedo = this.props.kedo
        const { multiple } = this.state

        return (
            <div>
                <h3>{kedo.t('Settings')}</h3>
                <FormControl fullWidth margin="normal">
                    <FormInputLabel>
                        {this.props.kedo.t('Multiple')}
                    </FormInputLabel>
                    <RadioGroup
                        row
                        value={multiple.toString()}
                        onChange={this.handleChange}
                    >
                        <FormControlLabel
                            value="true"
                            control={<Radio size="small" />}
                            label={kedo.t('Yes')}
                        />
                        <FormControlLabel
                            value="false"
                            control={<Radio size="small" />}
                            label={kedo.t('No')}
                        />
                    </RadioGroup>
                </FormControl>
            </div>
        )
    }
}

export default DefFieldUserSettings
